import React, { useState, useContext } from 'react'

import MyContext from '../components/MyContext'
import { filtersToString } from '../helpers'

const MERCHANT_URL = process.env.REACT_APP_MERCHANT_URL

export default () => {
	const [nextLink, setNextLink] = useState(`${MERCHANT_URL}/products?page=1`)
	const [data, setData] = useState([])
	const [loading, setLoading] = useState(false)
	const { mToken, showSnackbar } = useContext(MyContext)
	const paginate = 10

	const getProductList = async (reset, filters) => {
		if (nextLink == null && !reset) return
		const filterStr = filtersToString(filters)
		setLoading(true)

		const abortController = new AbortController()

		const timeout = setTimeout(() => {
			showSnackbar('Connection timeout, please try again! (1)', 'warning')
			abortController.abort()
			setLoading(false)

			return {status: false}
		}, 20000)

		try {
			const link = reset
				? `${MERCHANT_URL}/products?paginate=${paginate}&page=1${filterStr}`
				: `${nextLink}&paginate=${paginate}`
			const response = await fetch(`${link}`, {
				signal: abortController.signal,
				method: 'GET',
				headers: {
					Authorization: `Bearer ${mToken}`,
				},
			})

			if (response.status >= 400 && response.status <= 500) {
				showSnackbar('Please contact Marathon for this problem. (1)', 'error')
				clearTimeout(timeout)
				setLoading(false)

				return {status: false}
			}

			const responseData = await response.json()
			// console.log("FetchProductList:", responseData)  //debug

			if (responseData.status == 3) {
				showSnackbar('Session expired (1)', 'error')
				clearTimeout(timeout)
				setLoading(false)

				return {status: false}
			}

			if (responseData.status == 2) {
				showSnackbar('Something went wrong. (1)', 'warning')
				clearTimeout(timeout)
				setLoading(false)

				return {status: false}
			}

			if (responseData.status == 1) {
				clearTimeout(timeout)
				setLoading(false)

				if (reset) {
					setData(responseData.data)
				} else {
					setData(data.concat(responseData.data))
				}
				setNextLink(responseData.links.next)

				return {status: true}
			}
		} catch (e) {
			setLoading(false)
			showSnackbar('Connection problem, please try again. (1)', 'warning')
			clearTimeout(timeout)
			console.log(e)

			return {status: false}
		}
	}

	const getProductById = async (id) => {
		setLoading(true)

		const abortController = new AbortController()

		const timeout = setTimeout(() => {
			showSnackbar('Connection timeout, please try again! (2)', 'warning')
			abortController.abort()
			setLoading(false)

			return {status: false}
		}, 20000)
		try {
			const response = await fetch(`${MERCHANT_URL}/products/${id}`, {
				signal: abortController.signal,
				method: 'GET',
				headers: {
					Authorization: `Bearer ${mToken}`,
				},
			})

			if (response.status >= 400 && response.status <= 500) {
				showSnackbar('Please contact Marathon for this problem. (2)', 'error')
				clearTimeout(timeout)
				setLoading(false)

				return {status: false}
			}

			const responseData = await response.json()
			// console.log("getProductById: getProductByIdAsync", responseData)  //debug

			if (responseData.status == 3) {
				clearTimeout(timeout)
				setLoading(false)

				return {status: false}
			}

			if (responseData.status == 2) {
				showSnackbar('Something went wrong. (2)', 'warning')
				clearTimeout(timeout)
				setLoading(false)

				return {status: false}
			}

			if (responseData.status == 1) {
				clearTimeout(timeout)
				setLoading(false)

				return {status: true, payload: responseData.data}
			}
		} catch (e) {
			setLoading(false)
			clearTimeout(timeout)
			showSnackbar('Connection problem, please try again. (2)', 'warning')
			console.log(e)

			return {status: false}
		}
	}

	return {
		loading,
		data,
		getProductList,
		getProductById,
	}
}
